import ConstructionService from "../services/construction.service";
import MeasurementService from "../services/measurement.service";
import FilesService from "../services/files.service";
import importantEventsService from "@/services/importantEvents.service";
import router from "../router";
import { createDateAsUTC, dateToIsoString } from '@/utils/index.js';


const state = {
    info: {
        id: 0,
        user_id: 0,
        company_id: 0,
        parent_id: null,
        customer_id: 0,
        name: '',
        parent_name: null,
        pur: '',
        planned_start_date: null,
        planned_end_date: null,
        start_date: null,
        end_date: null,
        status: 'not_started',
        address: '',
        offer_price: 0,
        cost_materials: 0,
        cost_subcontractors: 0,
        cost_warehouse: 0,
        subprojects: [],
        color: null,
        created_at: null,
        updated_at: null
    },
    customer: {},
    manager: {},
    subcontractors: [],
    measurement: {},
    calculations: {},
    files: {},
    warehouseEvents: {},
    important_events: [],
    company: {},
};

const getters = {
    info: state => {
        return state.info;
    },
    customer: state => {
        return state.customer;
    },
    manager: state => {
        return state.manager;
    },
    subcontractors: state => {
        return state.subcontractors;
    },
    subcontractorsCount: state => {
        const filteredUser = state.subcontractors.filter(function (item) {
            return item.user_id > 0; // the condition for filter. Change this as you need.
        });
        return filteredUser.length;
    },
    measurement: state => {
        return state.measurement;
    },
    warehouseEvents: state => {
        return state.warehouseEvents;
    },
    calculations: state => {
        return state.calculations;
    },
    files: state => {
        return state.files;
    },
    importantEvents: state => {
        return state.important_events;
    },
    company: state => {
        return state.company;
    }
};

const actions = {
    async update({
        commit,
        state
    }, data) {
        let response = await ConstructionService.update(state.info.id, data);
        commit("info", response);
        commit("customer", response.customer);
        commit("manager", response.manager);
        commit("projectslist/update", response, {
            root: true
        });
        commit("company", response.company);
        return response;
    },
    async remove({
        commit,
        state
    }) {
        await ConstructionService.remove(state.info.id);
        commit("projectslist/remove", state.info.id, {
            root: true
        });
        router.push({
            path: "/construction"
        });
        commit("reset");
        return;
    },

    async loadSimpleInfo({ state }, construction_id) {
        let data = {};
        if (!state.info || state.info.id !== construction_id) {
            data = await ConstructionService.loadInfoById(construction_id);
        } else {
            data = state.info;
        }
        return data;
    },

    async getById({
        commit
    }, construction_id) {
        let response = await ConstructionService.loadById(construction_id);
        commit("info", response);
        commit("customer", response.customer);
        commit("manager", response.manager);
        commit("subcontractors", response.subcontractors);
        commit("measurement", response.measurement);
        commit('warehouseEvents', response.warehouse_events);
        commit("files", response.files);
        commit("importantEvents", response.important_events);
        commit("company", response.company);
        // commit("notes", response.notes);
        return response;
    },
    async offerprice({
        commit
    }, {
        construction_id,
        offerPrice
    }) {
        await ConstructionService.offerprice(construction_id, offerPrice);
        commit("infoprice", offerPrice);
        return true;
    },
    async updateSubcontractors({
        commit
    }, {
        construction_id,
        subcontractors_raw
    }) {
        let subcontractors = subcontractors_raw.filter((item) => {
            return item.user_id !== null && item.user_id >= 0;
        });
        await ConstructionService.subcontractors(construction_id, subcontractors);
        commit("subcontractors", subcontractors);
        return subcontractors;
    },
    async changeStatus({
        commit
    }, {
        construction_id,
        newStatus
    }) {
        let response = await ConstructionService.status(construction_id, newStatus);
        commit("changeStatus", {
            status: newStatus,
            start_date: response.start_date,
            end_date: response.end_date
        });
        commit('projectslist/reset', {}, {
            root: true
        });
        return true;
    },
    async changeDate({
        commit
    }, {
        construction_id,
        query
    }) {
        query.date = createDateAsUTC(query.date); //TODO: Move this to api service chcek varible and convert
        await ConstructionService.setDate(construction_id, query);
        commit("changeDate", query);
        commit('projectslist/updateField', {
            id: construction_id,
            key: query.type,
            value: query.date
        }, {
            root: true
        });
        return true;
    },
    //-- Pomiary
    async measurementHeight({
        commit,
        state
    }, height) {
        await MeasurementService.setHeight(state.info.id, height);
        commit("measurementHeight", height);
        return true;
    },
    async measurementRooms({
        commit,
        state
    }, newRooms) {

        await MeasurementService.setRooms(state.info.id, newRooms);
        commit("measurementRooms", newRooms);
        return true;
    },
    async measurementTiles({
        state
    }, newTiles) {
        let response = await MeasurementService.setTiles(state.info.id, newTiles);
        // commit("measurementTiles", tiles);
        return response;
    },
    async measurementItems({
        state
    }, newItems) {
        let response = await MeasurementService.setItems(state.info.id, newItems);
        return response;
    },
    //-- Pliki
    async fileRemove({
        state,
        commit
    }, {
        filesIds,
        categoryId
    }) {
        await FilesService.delete(state.info.id, filesIds);
        commit("fileDelete", {
            filesIds: filesIds,
            categoryId: categoryId
        });
    },
    // Important Events
    async importantEventsAdd({ state, commit }, query) {
        let response = await importantEventsService.add(state.info.id, {
            label: query.label,
            date: dateToIsoString(query.date),
        });
        commit("importantEvents", response);
        commit('projectslist/reset', {}, {
            root: true
        });
    },
    async importantEventsUpate({ commit }, newImportantEvents) {
        newImportantEvents.forEach(element => {
            if (element.date instanceof Date) {
                element.date = dateToIsoString(element.date);
            }
        });
        let response = await importantEventsService.update(state.info.id, newImportantEvents);
        commit("importantEvents", response);
        commit('projectslist/reset', {}, {
            root: true
        });
    },
};

const mutations = {
    info(state, {
        id,
        user_id,
        company_id,
        parent_id,
        name,
        parent_name,
        pur,
        planned_start_date,
        planned_end_date,
        start_date,
        end_date,
        status,
        address,
        offer_price,
        cost_materials,
        cost_warehouse,
        cost_subcontractors,
        customer_id,
        subprojects,
        color,
        created_at,
        updated_at
    }) {
        state.info = {
            id: id,
            user_id: user_id,
            company_id: company_id,
            parent_id: parent_id,
            customer_id: customer_id,
            name: name,
            parent_name: parent_name,
            pur: pur,
            planned_start_date: planned_start_date,
            planned_end_date: planned_end_date,
            start_date: start_date,
            end_date: end_date,
            status: status,
            address: address,
            offer_price: offer_price,
            cost_materials: cost_materials,
            cost_warehouse: cost_warehouse,
            cost_subcontractors: cost_subcontractors,
            subprojects: subprojects,
            color,
            created_at: created_at,
            updated_at: updated_at
        }
    },
    customer(state, payload) {
        state.customer = payload
    },
    manager(state, payload) {
        state.manager = payload
    },
    subcontractors(state, payload) {
        state.subcontractors = payload
    },
    measurement(state, payload) {
        state.measurement = payload
        state.calculations = calculation(payload);
    },
    warehouseEvents(state, payload) {
        state.warehouseEvents = payload;
    },
    files(state, payload) {
        state.files = payload
    },
    company(state, payload) {
        state.company = payload
    },
    // notes(state, payload) {
    //   state.notes = payload
    // },
    //-- Single update info
    infoprice(state, offer) {
        state.info.offer_price = offer;
    },
    costSubcontractors(state, cost) {
        state.info.cost_subcontractors = cost;
    },
    costMaterials(state, cost) {
        state.info.cost_materials = cost;
    },
    changeStatus(state, payload) {
        state.info.status = payload.status;
        state.info.start_date = payload.start_date;
        state.info.end_date = payload.end_date;
    },
    changeDate(state, {
        type,
        date
    }) {
        state.info[type] = date;
    },
    //-- Pomiary
    measurementHeight(state, newHeight) {
        state.measurement.height = parseFloat(newHeight).toFixed(2);
        state.calculations = calculation(state.measurement);
    },
    measurementRooms(state, newRooms) {
        state.measurement.rooms = newRooms;
        state.calculations = calculation(state.measurement);
    },
    measurementTiles(state, tiles) {
        state.measurement.tiles = tiles;
        state.calculations = calculation(state.measurement);
    },
    measurementItems(state, items) {
        state.measurement.items = items;
        state.calculations = calculation(state.measurement);
    },
    //-- Files
    fileDelete(state, {
        filesIds,
        categoryId
    }) {
        filesIds.forEach((id) => {
            let index = state.files[categoryId].findIndex((item) => item.id === id);
            if (index > -1) {
                state.files[categoryId].splice(index, 1);
            }
        });

    },
    fileAppend(state, {
        file,
        category_id
    }) {
        state.files[category_id].unshift(file);
    },
    filesCreateCategory(state, category_id) {
        if (!state.files[category_id]) {
            state.files[category_id] = [];
        }
    },
    // Important Events
    importantEvents(state, payload) {
        state.important_events = payload
    },

    reset(state) {
        state.info.id = 0;
        state.info.user_id = 0;
        state.info.company_id = 0;
        state.info.parent_id = null;
        state.info.customer_id = 0;
        state.info.name = '';
        state.info.parent_name = null;
        state.info.pur = '';
        state.info.planned_start_date = null;
        state.info.planned_end_date = null;
        state.info.start_date = null;
        state.info.end_date = null;
        state.info.status = 'not_started';
        state.info.address = '';
        state.info.offer_price = 0;
        state.info.subprojects = [],
            state.info.color = null,
            state.info.created_at = null;
        state.info.updated_at = null;
        state.customer = {};
        state.manager = {};
        state.subcontractors = [];
        state.measurement = {};
        state.calculations = {};
        state.files = {};
        state.company = {};
        // state.notes = [];
    }
};

const calculation = function (measurement) {
    if (!measurement) return {};
    let cal = {
        walls: 0,
        ceiling: 0,
        wallpaper: 0,
        ceiling_gkbi: 0,
        celling_gk: 0,
        parquet: 0,
        tiles_floor_to_isulation: 0,
        tiles_floor: 0,
        tiles_wall: 0,
        plinth: 0, //cokół
        baseboard: 0, //listwa przypodłogowa,
        alternative_insulation: 0,
        silicone_joints: 0
    }
    measurement.tiles.forEach((tile) => {
        let sum = 0;
        if (tile.width) {
            tile.width.forEach((value) => {
                sum += parseFloat(value);
            })
        }
        cal.tiles_wall += sum * (parseInt(tile.h) / 100);
    })
    measurement.rooms.forEach((item) => {
        let perimeter = (2 * item.lenght + 2 * item.width);
        let roomWall = (perimeter * parseFloat(measurement.height)) || 0;
        let roomFloor = item.lenght * item.width;
        cal.walls += roomWall;
        cal.ceiling += roomFloor;
        if (item.wallpapertoremove_walls == "1") {
            cal.wallpaper += roomWall
        }
        if (item.wallpapertoremove_ceiling == "1") {
            cal.wallpaper += roomFloor
        }

        if (item.suspendedceiling == "1") {
            if (item.name === 'bathroom' || item.name === 'toilet') {
                cal.ceiling_gkbi += roomFloor;
            } else {
                cal.celling_gk += roomFloor;
            }
        }
        if (item.floor === 'wood') {
            cal.parquet += roomFloor
            cal.baseboard += perimeter;
        } else if (item.floor === 'tiles') {
            cal.tiles_floor += roomFloor;
            if (item.name === 'bathroom' || item.name === 'toilet') {
                cal.tiles_floor_to_isulation += roomFloor;
            }
            cal.plinth += perimeter;
        }
    })
    cal.alternative_insulation = cal.tiles_floor_to_isulation + cal.tiles_wall;
    cal.silicone_joints = cal.tiles_wall + cal.plinth;
    return cal;
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};